export default __webpack_public_path__ + "static/highlight-1-mobile-26676e4e1aaae2a963e4ffa660fc92aa.svg";